import { FC } from 'react';
import { ITableFetchPaginationProps } from './types';
import MantisPagination from './MantisPagination';

export const TableFetchPagination: FC<ITableFetchPaginationProps> = ({
	totalPages,
	page,
	items,
	setPage,
	setItems,
	totalItems
}) => (
	<MantisPagination
		// `|| 0` — if the BE omits the counters (non-envelope response), NaN would break Pagination.
		count={totalItems || items * totalPages || 0}
		page={page}
		rowsPerPage={items}
		onPageChange={setPage}
		onRowsPerPageChange={setItems}
		rowsPerPageOptions={[3, 5, 10]}
	/>
);
